export default {
    ATENDIMENTO_PACIENTES_NECESSIDADES_ESPECIAIS: 1,
    CIRURGIA_BMF: 2,
    ENDODONTIA: 3,
    ESTOMATOLOGIA: 4,
    IMPLANTODONTIA: 5,
    ODONTOPEDIATRIA: 6,
    ORTODONTIA_ORTOPEDIA: 7,
    PERIDONTIA: 8,
    PROTESE_DENTARIA: 9,
    RADIOLOGIA: 10,
    OUTROS: 11,
    AGENDAMENTO_OUTROS_PROFISSIONAIS: 12,
    AGENDAMENTO_NASF: 13,
    AGENDAMENTO_GRUPOS: 14,
    TRATAMENTO_CONCLUIDO: 15,
    RETORNO_CONSULTA_AGENDADA: 16,
    ALTA_EPISODIO: 17,
    AGENDAMENTO_EMULTI: 18,
}